import api from 'service/api'

const dponetAPInotTrait = api.create('dponet', false)

const get = async ({ ...params }) => {
  return await dponetAPInotTrait.get('/public/regulation_versions', { params })
}

const accept = async ({ regulationVersionAcceptance, ...data }) => {
  return await dponetAPInotTrait.post(`public/regulation_version_acceptances`, {
    regulationVersionAcceptance,
    ...data,
  })
}

const regulationVersions = {
  get,
  accept,
}

export default regulationVersions
